// extracted by mini-css-extract-plugin
module.exports = {"context":"_31c354a"};